"use client"

import { useState, useEffect, useRef } from "react"
import axios from "axios"
import jsPDF from "jspdf"
import "jspdf-autotable"
import Modal from "react-modal"
import { FaEye, FaPrint, FaSearch, FaArrowRight, FaArrowLeft, FaTimes, FaClipboardList } from "react-icons/fa"
import logo from "../assets/2.png" // Adicione sua logo na pasta assets
import "../styles/vendasDono.css"
import '../styles/meusPedidos.css';
import JsBarcode from 'jsbarcode';

Modal.setAppElement("#root")

const VendasDono = () => {
  const [eventos, setEventos] = useState([])
  const [categorias, setCategorias] = useState([])
  const [vendas, setVendas] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [statusPagamento, setStatusPagamento] = useState("")
  const [buscaVaqueiro, setBuscaVaqueiro] = useState("")
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [detalhesPedido, setDetalhesPedido] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showScrollIndicator, setShowScrollIndicator] = useState(false)
  const tableContainerRef = useRef(null)

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true)
        const response = await axios.get("https://api.ticketdovaqueiro.com/api/events/dono", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        setEventos(response.data)
        setLoading(false)
      } catch (error) {
        console.error("Erro ao buscar eventos:", error)
        setLoading(false)
      }
    }
    fetchEventos()
  }, [])

  useEffect(() => {
    const fetchCategorias = async () => {
      if (eventoSelecionado) {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://api.ticketdovaqueiro.com/api/events/${eventoSelecionado}/categorias`,
            {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            },
          )
          setCategorias(response.data)
          setLoading(false)
        } catch (error) {
          console.error("Erro ao buscar categorias:", error)
          setLoading(false)
        }
      }
    }
    fetchCategorias()
  }, [eventoSelecionado])

  useEffect(() => {
    const buscarVendas = async () => {
      if (eventoSelecionado && categoriaSelecionada) {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://api.ticketdovaqueiro.com/api/pedidos/senhas-detalhadas/${eventoSelecionado}/${categoriaSelecionada}`,
            {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            },
          )
          let vendasFiltradas = response.data

          if (statusPagamento) {
            vendasFiltradas = vendasFiltradas.filter((venda) => venda.statusPagamento === statusPagamento)
          }
          if (buscaVaqueiro) {
            vendasFiltradas = vendasFiltradas.filter((venda) =>
              venda.nomeVaqueiro?.toLowerCase().includes(buscaVaqueiro.toLowerCase()),
            )
          }

          setVendas(vendasFiltradas)
          setLoading(false)
          
          // Verificar se a tabela precisa de scroll horizontal
          setTimeout(() => {
            checkTableOverflow();
          }, 300);
        } catch (error) {
          console.error("Erro ao buscar vendas:", error)
          setLoading(false)
        }
      } else {
        setVendas([])
      }
    }

    buscarVendas()
  }, [eventoSelecionado, categoriaSelecionada, statusPagamento, buscaVaqueiro])
  
  // Verificar se a tabela precisa de scroll horizontal
  const checkTableOverflow = () => {
    if (tableContainerRef.current) {
      const container = tableContainerRef.current;
      setShowScrollIndicator(container.scrollWidth > container.clientWidth);
    }
  };
  
  // Adicionar listener de redimensionamento
  useEffect(() => {
    window.addEventListener('resize', checkTableOverflow);
    return () => {
      window.removeEventListener('resize', checkTableOverflow);
    };
  }, []);

  const abrirModal = (venda) => {
    const nomeEventoSelecionado = eventos.find((ev) => ev._id === eventoSelecionado)?.nome || "Evento não encontrado";

    const pedidoFormatado = {
      ...venda,
      nomeEvento: nomeEventoSelecionado, // <- injeta o nome do evento
      senhas: [
        {
          numero: venda.numeroSenha,
          status: venda.statusSenha,
          boiTv: venda.boiTv || false,
          taxasOpcionaisSelecionadas: venda.taxasOpcionaisSelecionadas || []
        }
      ]
    };
    setDetalhesPedido(pedidoFormatado);
    setModalIsOpen(true);
  };

  const fecharModal = () => {
    setModalIsOpen(false)
    setDetalhesPedido(null)
  }

  const gerarPDFIndividual = (venda) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const nomeEventoSelecionado = eventos.find((ev) => ev._id === eventoSelecionado)?.nome || "Evento não encontrado";
    const nomeEvento = nomeEventoSelecionado?.toUpperCase()?.replace(" DO ", "\nDO ") || "EVENTO";
    const codigoAutenticacao = venda._id?.slice?.(-6)?.toUpperCase?.() + "-" + Math.floor(100000 + Math.random() * 900000);
  
    // Logo
    const img = new Image();
    img.src = logo;
    img.crossOrigin = "anonymous";
  
    img.onload = () => {
      doc.addImage(img, "PNG", 75, 5, 45, 20);
  
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(nomeEvento, pageWidth / 2, 30, { align: "center" });
  
      // DADOS DO VAQUEIRO
      doc.setDrawColor("#FFD700");
      doc.setFillColor("#FFD700");
      doc.rect(10, 43, pageWidth - 20, 10, "F");
      doc.setFontSize(14);
      doc.text("DADOS DO VAQUEIRO", pageWidth / 2, 50, { align: "center" });
  
      doc.setFontSize(11);
      const linha = (label, valor, x, y) => {
        doc.setFont("helvetica", "bold");
        doc.text(label, x, y);
      
        const labelWidth = doc.getTextWidth(label); // 👈 mede a largura exata do label
      
        doc.setFont("helvetica", "normal");
        doc.text(valor || "Não informado", x + labelWidth + 2, y); // 👈 coloca o valor logo após o label
      };
      
      linha("NOME DO VAQUEIRO:", venda.nomeVaqueiro, 10, 60);
      linha("CPF:", venda.cpf, 10, 68);
      linha("NOME DO ESTEIRA:", venda.nomeEsteira, 10, 76);
      linha("CAVALO DE PUXADA:", venda.cavaloPuxar, 10, 84);
      linha("CAVALO DE ESTEIRA:", venda.cavaloEsteira, 10, 92);
      linha("REPRESENTAÇÃO:", venda.representacao, 10, 100);
      linha("CIDADE:", venda.cidade, 10, 108);
  
      // INFORMAÇÕES DO PEDIDO
      doc.setDrawColor("#FFD700");
      doc.setFillColor("#FFD700");
      doc.rect(10, 116, pageWidth - 20, 10, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("INFORMAÇÕES DO PEDIDO", pageWidth / 2, 123, { align: "center" });
  
      doc.setFontSize(11);
      linha("CATEGORIA:", venda.categoria, 10, 132);
      linha("FORMA DE PAGAMENTO:", venda.metodoPagamento, 10, 140);
      linha("STATUS PAGAMENTO:", venda.statusPagamento?.toUpperCase(), 10, 148);
      linha("TOTAL:", `R$ ${Number(venda.total).toFixed(2).replace(".", ",")}`, 10, 156);
  
      // SENHAS
      doc.setDrawColor("#FFD700");
      doc.setFillColor("#FFD700");
      doc.rect(10, 164, pageWidth - 20, 10, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("SENHAS ADQUIRIDAS", pageWidth / 2, 171, { align: "center" });
  
      doc.setFillColor(255, 236, 93);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
  
      const colunasPorLinha = 4;
      const larguraColuna = 45;
      const altura = 28;
      const espacamento = 5;
      let startY = 180;
  
      const senhas = [{
        numero: venda.numeroSenha,
        status: venda.statusSenha,
        boiTv: venda.boiTv || false,
        taxasOpcionaisSelecionadas: venda.taxasOpcionaisSelecionadas || []
      }];


  
      senhas.forEach((senha, i) => {
        const col = i % colunasPorLinha;
        const row = Math.floor(i / colunasPorLinha);
        const x = 15 + col * (larguraColuna + espacamento);
        const y = startY + row * (altura + 10);
  
        doc.roundedRect(x, y, larguraColuna, altura, 3, 3, "F");

        const centerX = x + (larguraColuna / 2);

        // Título
        doc.setFont("helvetica", "bold").setFontSize(10);
        const titulo = `SENHA ${i + 1}`;
        doc.text(titulo, centerX - doc.getTextWidth(titulo) / 2, y + 6);

        // Número da senha
        doc.setFontSize(30);
        const numeroTexto = `${senha.numero}`;
        doc.text(numeroTexto, centerX - doc.getTextWidth(numeroTexto) / 2, y + 15);

        // BOI TV
        doc.setFont("helvetica", "normal").setFontSize(10);
        const boiTvTexto = `BOI TV: ${senha.boiTv ? "SIM" : "NÃO"}`;
        doc.text(boiTvTexto, centerX - doc.getTextWidth(boiTvTexto) / 2, y + 22);

        // Taxas opcionais (se houver)
        if (Array.isArray(senha.taxasOpcionaisSelecionadas) && senha.taxasOpcionaisSelecionadas.length > 0) {
          doc.setFontSize(8);
          senha.taxasOpcionaisSelecionadas.forEach((taxa, j) => {
            const taxaTexto = `${taxa.nome.toUpperCase()}: R$ ${taxa.valor.toFixed(2).replace(".", ",")}`;
            doc.text(taxaTexto, centerX - doc.getTextWidth(taxaTexto) / 2, y + 26 + (j * 4));
          });
        }



      });
  
      // AUTENTICADOR
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, codigoAutenticacao, {
        format: "CODE128",
        width: 1.5,
        height: 10,
        displayValue: false,
        margin: 0,
      });
      const barcodeImage = canvas.toDataURL("image/png");
      const barcodeWidth = 80;
      const barcodeX = (pageWidth - barcodeWidth) / 2;
      const barcodeY = 268;
  
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text("Autenticidade do Pedido", pageWidth / 2, barcodeY, { align: "center" });
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(`Código: ${codigoAutenticacao}`, pageWidth / 2, barcodeY + 6, { align: "center" });
  
      doc.addImage(barcodeImage, "PNG", barcodeX, barcodeY + 8, barcodeWidth, 15);
  
      doc.save(`venda-${venda.numeroSenha}.pdf`);
    };
  };

  return (
    <div className="vendas-dono">
      <div className="rv-vendas-content">
        <h2>Vendas</h2>
        <div className="filtros">
          <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)} disabled={loading}>
            <option value="">Selecione um evento</option>
            {eventos.map((evento) => (
              <option key={evento._id} value={evento._id}>
                {evento.nome}
              </option>
            ))}
          </select>

          <select
            value={categoriaSelecionada}
            onChange={(e) => setCategoriaSelecionada(e.target.value)}
            disabled={!categorias.length || loading}
          >
            <option value="">Selecione uma categoria</option>
            {categorias.map((categoria) => (
              <option key={categoria._id} value={categoria.nome}>
                {categoria.nome}
              </option>
            ))}
          </select>

          <select
            value={statusPagamento}
            onChange={(e) => setStatusPagamento(e.target.value)}
            disabled={!eventoSelecionado || !categoriaSelecionada || loading}
          >
            <option value="">Todos os status</option>
            <option value="pago">Pago</option>
            <option value="pendente">Pendente</option>
          </select>

          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Buscar por nome do vaqueiro"
              value={buscaVaqueiro}
              onChange={(e) => setBuscaVaqueiro(e.target.value)}
              disabled={!eventoSelecionado || !categoriaSelecionada || loading}
            />
          </div>
        </div>

        <div className="table-container" ref={tableContainerRef}>
          <table className="tabela-vendas">
            <thead>
              <tr>
                <th>Nº Senha</th>
                <th>Nome Vaqueiro</th>
                <th>CPF</th>
                <th>Status Pagamento</th>
                <th>Total</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-cell">
                    Carregando...
                  </td>
                </tr>
              ) : vendas.length > 0 ? (
                vendas.map((venda) => (
                  <tr key={venda.pedidoId + "-" + venda.numeroSenha}>
                    <td>{venda.numeroSenha}</td>
                    <td>{venda.nomeVaqueiro}</td>
                    <td>{venda.cpf}</td>
                    <td>
                      <span className={`status-${venda.statusPagamento.toLowerCase()}`}>{venda.statusPagamento}</span>
                    </td>
                    <td>R$ {Number.parseFloat(venda.total).toFixed(2)}</td>
                    <td>
                      <FaEye className="icon-action" onClick={() => abrirModal(venda)} title="Ver detalhes" />
                      <FaPrint
                        className="icon-action"
                        onClick={() => gerarPDFIndividual(venda)}
                        style={{ marginLeft: "10px" }}
                        title="Gerar PDF"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="empty-cell">
                    Nenhuma venda encontrada
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
        {showScrollIndicator && (
          <div className="scroll-indicator">
            <FaArrowLeft /> Deslize para visualizar toda a tabela <FaArrowRight />
          </div>
        )}

<Modal
  isOpen={modalIsOpen}
  onRequestClose={fecharModal}
  contentLabel="Detalhes do Pedido"
  className="hg-modal-content"
  overlayClassName="hg-modal-overlay"
>
  {detalhesPedido && (
    <div onClick={(e) => e.stopPropagation()}>
      <button className="hg-close-button close" onClick={fecharModal}>
        <FaTimes />
      </button>

      <div className="hg-modal-header">
        <FaClipboardList className="hg-modal-icon" />
        <h2>Detalhes do Pedido</h2>
      </div>

      <div className="hg-modal-body">
        {/* Informações do Pedido */}
        <div className="hg-detail-section">
          <h3>Informações do Pedido</h3>
          <div className="hg-detail-grid">
            <div className="hg-detail-item">
              <span className="hg-detail-label">Evento:</span>
              <span className="hg-detail-value">{detalhesPedido.nomeEvento || "N/A"}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Forma de Pagamento:</span>
              <span className="hg-detail-value">{detalhesPedido.metodoPagamento || "N/A"}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Status Pagamento:</span>
              <span className="hg-detail-value">{detalhesPedido.statusPagamento}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Categoria:</span>
              <span className="hg-detail-value">{detalhesPedido.categoria}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Data da Compra:</span>
              <span className="hg-detail-value">
                {new Date(detalhesPedido.dataCriacao).toLocaleString("pt-BR")}
              </span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Total:</span>
              <span className="hg-detail-value">
                R$ {Number.parseFloat(detalhesPedido.total).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        {/* Dados do Vaqueiro */}
        <div className="hg-detail-section">
          <h3>Dados do Vaqueiro</h3>
          <div className="hg-detail-grid">
            <div className="hg-detail-item">
              <span className="hg-detail-label">Nome Vaqueiro:</span>
              <span className="hg-detail-value">{detalhesPedido.nomeVaqueiro}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">CPF:</span>
              <span className="hg-detail-value">{detalhesPedido.cpf}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Nome Esteira:</span>
              <span className="hg-detail-value">{detalhesPedido.nomeEsteira}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Cavalo Puxar:</span>
              <span className="hg-detail-value">{detalhesPedido.cavaloPuxar}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Cavalo Esteira:</span>
              <span className="hg-detail-value">{detalhesPedido.cavaloEsteira}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Representação:</span>
              <span className="hg-detail-value">{detalhesPedido.representacao}</span>
            </div>
            <div className="hg-detail-item">
              <span className="hg-detail-label">Cidade:</span>
              <span className="hg-detail-value">{detalhesPedido.cidade}</span>
            </div>
          </div>
        </div>

        {/* Senhas */}
        <div className="hg-detail-section">
          <h3>Senhas</h3>
          <div className="hg-senhas-grid">
            {detalhesPedido.senhas?.map((senha, index) => (
              <div key={index} className={`hg-senha-card hg-status-${senha.status}`}>
                <div className="hg-senha-number">Nº {senha.numero}</div>
                <div className="hg-senha-info">
                  <span className="hg-senha-label">Status:</span>
                  <span className="hg-senha-status">{senha.status}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )}
</Modal>

      </div>
    </div>
  )
}

export default VendasDono